import { render, staticRenderFns } from "./ButtonComponent.vue?vue&type=template&id=2af81f4f"
import script from "./ButtonComponent.vue?vue&type=script&lang=ts"
export * from "./ButtonComponent.vue?vue&type=script&lang=ts"
import style0 from "./ButtonComponent.vue?vue&type=style&index=0&id=2af81f4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports